// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-appbar[data-v-1b968762] {\n  box-shadow: 0px 4px 5px rgba(210, 210, 210, 255);\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background-color: #f8f8f8;\n  min-height: 60px;\n  height: 60px;\n}\n", ""]);
// Exports
module.exports = exports;
